<template>
  <button class="rounded-md border-indigo-500 ring-2 ring-indigo-500 bg-white p-4 h-12 text-center align-middle text-indigo-500 font-small hover:bg-indigo-600 hover:text-white ml-4" @click="openModal()"><i class="far fa-envelope" />
    <ModalHeadlessUI ref="modal">
      <template #default>
        <div>
          <h1 class="font-bold mb-4 text-3xl text-center">
            Send Mass Email
          </h1>
          <p class="text-center mb-4 text-l">
            (Sending to {{ selectAllFromDatabase ? totalMatchingCount : emailSelected.length }} Recipients)
          </p>
        </div>
        <form id="emailForm" name="emailForm" @submit.prevent="sendEmail">
          <select-input :key="emailTemplate.id" v-model="emailTemplate" class="pb-4 w-full" label="Email Template Options" @change="onTemplateChange($event)">
            <option v-for="emailSingle in emailTemplateOptions" :key="emailSingle.id" :value="emailSingle.id">{{ emailSingle.title }}</option>
          </select-input>
          <text-input v-model="emailForm.emailSubjectModal" :error="emailForm.errors.emailSubjectModal" class="pr-6 pb-4 w-full" label="Email Subject" />
          <label class="form-label">Email Message:</label>
          <div class="flex items-center gap-2 mb-2">
            <button
              id="loom-record-sdk-button"
              type="button"
              class="inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 font-normal rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              @click="initializeLoom"
            >
              <i class="fas fa-video mr-2"></i>
              Record Video
            </button>
          </div>
          <EmailEditor
            v-model="emailForm.emailMessageModal"
            :error="emailForm.errors.emailMessageModal"
            ref="emailEditor"
            @change-email="updateEmail($event)"
          />
          <div v-if="emailForm.errors.emailMessageModal" class="form-error">{{ emailForm.errors.emailMessageModal }}</div>
          <attachment-uploader :initial-attachment-url="emailForm.attachment" message-type="email" @update:attachmentUrl="updateAttachmentUrl" @update:attachmentName="updateAttachmentName"/>
          <div class="flex justify-center items-center mt-5">
            <div>
              <loading-button :loading="emailForm.processing" class="btn-indigo ml-auto" type="submit">Send Email</loading-button>
            </div>
          </div>
        </form>
      </template>
    </ModalHeadlessUI>
  </button>
</template>

<script>
import ModalHeadlessUI from '@/Shared/ModalHeadlessUI'
import EmailEditor from '@/Shared/EmailEditor'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import AttachmentUploader from '@/Shared/AttachmentUploader'
import { router } from '@inertiajs/vue3'
import { setup } from '@loomhq/record-sdk'
import { isSupported } from '@loomhq/record-sdk/is-supported'
import { usePage } from '@inertiajs/vue3'
import * as loomEmbedSDK from '@loomhq/loom-embed'

export default {
  components: {
    ModalHeadlessUI,
    EmailEditor,
    SelectInput,
    TextInput,
    LoadingButton,
    AttachmentUploader,
  },
  props: {
    emailSelected: {
      type: Array,
      required: true
    },
    emailTemplates: Array,
    auth: Object,
    url: String,
    formFilters: Object,
    selectAllFromDatabase: Boolean,
    totalMatchingCount: Number,
  },
  watch: {
    emailSelected: {
      immediate: true,
      handler(newVal) {
        this.emailForm.emailSelected = newVal
      }
    }
  },
  data() {
    return {
      emailForm: router.form({
        emailSelected: this.emailSelected,
        emailSubjectModal: '',
        emailMessageModal: '',
        attachmentName: '',
        attachment: '',
        selectAllFromDatabase: false,
        formFilters: null,
      }),
      emailTemplate: '',
      attachmentError:'',
      userInfo:
        {
          user_email: this.auth.user.email,
          user_phone: this.auth.user.phone,
          user_first_name: this.auth.user.first_name,
          user_last_name: this.auth.user.last_name,
          user_nmls: this.auth.user.nmls,
          user_application_link: this.auth.user.application_link,
          user_appointment_link: this.auth.user.appointment_link,
        },
      buttonConfigured: false,
    }
  },
  computed:{
    emailTemplateOptions() {
      var emailTemplateOptions= this.emailTemplates
      return emailTemplateOptions
    },
    urlPost() {
      return this.url || '/emailMass'
    },
  },
  methods:{
    openModal() {
      this.$refs.modal.openModal()
    },
    closeModal() {
      this.$refs.modal.closeModal()
    },
    onTemplateChange: function(event){

      let emailTemplateId = parseInt(event.target.value)
      console.log(emailTemplateId)

      this.emailForm.emailSubjectModal = this.emailTemplates.find(item => item.id === emailTemplateId).subject
      let message = this.emailTemplates.find(item => item.id === emailTemplateId).message
      let subject = this.emailTemplates.find(item => item.id === emailTemplateId).subject
      let attachment = this.emailTemplates.find(item => item.id === emailTemplateId).attachment

      Object.keys(this.userInfo).forEach(key => {
        const regex = new RegExp('%' + key + '%', 'g')
        message = message.replace(regex, this.userInfo[key])
        this.emailForm.emailMessageModal = message.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '<br>')
        subject = subject.replace(regex, this.userInfo[key])
        this.emailForm.emailSubjectModal = subject
        this.emailForm.attachment = attachment
      })
    },
    updateEmail: function(emailValue){
      this.emailForm.emailMessageModal=emailValue
    },
    removeAttachment() {
      this.emailForm.attachment=null
      this.emailForm.attachmentName=null
    },
    isImage(url) {
      // Regular expression to match common image extensions
      const imageExtensions = /\.(jpg|jpeg|png|gif)$/i;
      return imageExtensions.test(url);
    },
    updateAttachmentUrl(url) {
      this.emailForm.attachment = url
    },
    updateAttachmentName(name) {
      this.emailForm.attachmentName = name
    },
    sendEmail() {
      // Add selectAllFromDatabase and formFilters to the form data
      this.emailForm.selectAllFromDatabase = this.selectAllFromDatabase;
      if (this.selectAllFromDatabase) {
        this.emailForm.formFilters = this.formFilters;
      }
      
      console.log('Form data:', this.emailForm.data());
      
      this.emailForm.post(this.urlPost, {
        onSuccess: () => {
          this.emailForm.reset('emailSubjectModal');
          this.emailForm.reset('emailMessageModal');
          this.emailForm.reset('emailSelected');
          this.emailForm.reset('selectAllFromDatabase');
          this.emailForm.reset('formFilters');
          this.$emit('update:selected', []);
          this.closeModal();
        },
      });
    },
    async initializeLoom() {
      if (this.buttonConfigured) {
        return
      }

      const { supported, error } = await isSupported()

      if (!supported) {
        console.warn(`Error setting up Loom: ${error}`)
        return
      }

      const button = document.getElementById('loom-record-sdk-button')

      if (!button) {
        console.error('Loom button not found')
        return
      }

      try {
        console.log('Setting up Loom with public app ID:', usePage().props.loom.publicAppId)
        const { configureButton } = await setup({
          publicAppId: usePage().props.loom.publicAppId,
          mode: 'standard',
          insertButtonText: 'Add to Email',
          defaultTimeLimit: 300,
          config: {
            allowedRecordingTypes: ['screen_cam', 'cam'],
            enablePictureInPicture: true,
            styles: {
              recordButtonColor: '#4F46E5',
              primaryColor: '#4F46E5'
            }
          }
        })

        const sdkButton = configureButton({ element: button })

        this.buttonConfigured = true

        sdkButton.on('insert-click', async (video) => {
          try {
            console.log('Loom video object on insert-click:', video);
            const editor = this.$refs.emailEditor.editor;

            if (editor) {
              let duration = 1;
              const options = {
                width: 640,
                height: 360,
                gifThumbnail: true
              };
              const oembedData = await loomEmbedSDK.oembed(video.sharedUrl, options);
              console.log('Oembed data:', oembedData);

              if (oembedData.duration) {
                duration = Math.round(oembedData.duration);
              }

              const thumbnailHtml = `
                <div style="margin: 0; padding: 0; text-align: center; width: 100%; max-width: 640px; margin: auto;">
                  <a href="${video.sharedUrl}" target="_blank" style="text-decoration: none;">
                    <img src="${oembedData.thumbnail_url}" 
                         alt="Video Thumbnail: Click to watch the video" 
                         style="display: block; max-width: 100%; height: auto; border: 0; margin: 0 auto;" />
                  </a>
                  <p style="font-family: Arial, sans-serif; font-size: 14px; line-height: 1.5; color: #333333; margin-top: 12px; text-align:center;">
                    <a href="${video.sharedUrl}" target="_blank" 
                       style="color: #3EB1E5; text-decoration: none; font-weight: bold;">
                      ▶️ Click Here to Watch: ${oembedData.title} (${duration}s)
                    </a>
                  </p>
                </div>
                <p>
                  Hey %first%,
                </p>
                <p>
                  I recorded a quick video for you! Click the link above to watch.
                </p>
              `;

              editor.model.change(writer => {
                const viewFragment = editor.data.processor.toView(thumbnailHtml);
                const modelFragment = editor.data.toModel(viewFragment);
                editor.model.insertContent(modelFragment);
              });

              const newContent = editor.getData();
              this.emailForm.emailMessageModal = newContent;
              this.updateEmail(newContent);
              this.$refs.emailEditor.data.description = newContent;
            }
          } catch (error) {
            console.error('Error inserting video:', error);
          }
        });

        sdkButton.on('recording-complete', (video) => {
          console.log('Recording complete:', video);
        });

        sdkButton.on('upload-complete', (video) => {
          console.log('Upload complete:', video);
        });

        sdkButton.on('processing-complete', (video) => {
          console.log('Processing complete:', video);
        });

      } catch (error) {
        console.error('Error setting up Loom button:', error)
      }
    },
  },
}
</script>
